<template>
  <button
    @click="toggleMode"
    class="dark-mode-toggle"
    :aria-label="darkMode ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <span class="icon">{{ darkMode ? "☀️" : "🌙" }}</span>
  </button>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "DarkModeToggle",
  computed: {
    ...mapState(["darkMode"]),
  },
  methods: {
    ...mapActions(["toggleDarkMode"]),
    toggleMode() {
      this.toggleDarkMode();
    },
  },
};
</script>

<style scoped>
.dark-mode-toggle {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  align-self: flex-end;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  margin-bottom: 3px;
}

.dark-mode-toggle:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.1);
}

.dark-mode-toggle:active {
  transform: scale(0.95);
}

.icon {
  font-size: 1.2rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .dark-mode-toggle {
    width: 36px;
    height: 36px;
  }

  .icon {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .dark-mode-toggle {
    width: 34px;
    height: 34px;
  }

  .icon {
    font-size: 1rem;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .dark-mode-toggle {
    transition: none;
  }

  .dark-mode-toggle:hover {
    transform: none;
  }
}
</style>
